<app-alert-modal *ngIf="cs.isBrowser" (confirmed)="confirmed()" (canceled)="handleCancel($event)" #giveawayAnswer
  dynamicClass="give-away-response" [headerLabel]="modalHeader" [cancelBtnLabel]="labels.CANCEL"
  [confirmBtnLabel]="labels.SUBMIT" [confirmBtnLoading]="isSubmitting" [disableConfirmButton]="isSubmitting"
  [modalOptions]="{ class: 'modal-lg' }" [closeModalOnSuccess]="false">
  <div class="d-flex flex-column gap-1">
    <div class="discription-padding-top">{{ giveAwayData?.description }}</div>
  </div>
  <app-dynamic-form-builder [form]="form" [fields]="formFields"></app-dynamic-form-builder>


  <div class="form-group-btn form-group-link giveaway-form-link">
    {{ labels.GOVEAWAY_POLICY }}
    <a (click)="openLink('terms-of-service')" class="btn btn-link decoration-none">
      Terms&nbsp;of&nbsp;Service
    </a>
    and
    <a (click)="openLink('privacy-policy')" class="btn btn-link decoration-none">
      Privacy&nbsp;Policy.
    </a>
  </div>
</app-alert-modal>
<app-alert-modal *ngIf="cs.isBrowser" #successModal dynamicClass="give-away-success-modal" [showCrossBtnInBody]="true"
  (confirmed)="handleSuccess()" (canceled)="handleSuccess()">
  <div class="d-flex align-items-center justify-content-center flex-column gap-2">
    <img appMobileOptimization [originalUrl]="'../../../../../assets/images/svg/fire-cracker.svg'" src="../../../../../assets/images/svg/fire-cracker.svg" [format]="'webp'" alt="Success" loading="lazy" decoding="async" />
    <div class="success-header">{{ labels.SUBMISSION_ACCEPTED }}</div>
    <div class="success-body">{{ labels.THANKS_FOR_PARTICIPATING }}</div>
  </div>
</app-alert-modal>